export class SchemaProperty {
  hints: string;
  label: string;
  tags: string[];
}
